import { render, staticRenderFns } from "./cr_index.vue?vue&type=template&id=28a3ca76&"
import script from "./cr_index.vue?vue&type=script&lang=js&"
export * from "./cr_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a3ca76')) {
      api.createRecord('28a3ca76', component.options)
    } else {
      api.reload('28a3ca76', component.options)
    }
    module.hot.accept("./cr_index.vue?vue&type=template&id=28a3ca76&", function () {
      api.rerender('28a3ca76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/crud/cr_index.vue"
export default component.exports